import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import PatientImage from "../../../PatientImage"
import moment from "moment"
import {
    getPatientName,
    getPatientAge,
    renderSearchHighlight,
    getPatientMRN
} from "../../../../lib"


export default class PatientItem extends React.Component {
    /**
     * This component expects a Fhir Bundle
     */
    static propTypes = {
        query: PropTypes.object,
        settings: PropTypes.object,
        onSelectionChange: PropTypes.func,
        index: PropTypes.number,
        onClick: PropTypes.func // Add onClick prop
    };

    static defaultProps = {
        onSelectionChange: () => 1,
        onClick: () => { }
    };

    handleClick = () => {
        this.props.onClick();
    }

    render() {
        let age = getPatientAge(this.props.patientDOB)
        return (
            <div
                // to={"/view/patient-info/" + this.props.allergyTableKey + "/" + this.props.diagnosisTableKey}
                className={"patient"}
                onClick={this.handleClick} // Add onClick handler
                style={{ cursor: 'pointer' }} // Change cursor to indicate clickable
            >
                <div className="patient-info">
                    <b>{this.props.patientFirstName + " " + this.props.patientLastName}</b>
                    <small><b>{age}</b> old</small>
                    <footer className="small">
                        <span>
                            DOB: {this.props.patientDOB || "Unknown"}
                        </span>
                        <span>ID: {this.props.messageID || "Unknown"}</span>
                        <span>MRN: {this.props.patientMRN || "Unknown"}</span>
                    </footer>
                </div>
                <i className="fa fa-angle-right" />
            </div>
        )
    }
}